import { render } from "./KeywordMix.vue?vue&type=template&id=f4d533f6"
import script from "./KeywordMix.vue?vue&type=script&lang=js"
export * from "./KeywordMix.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__